module.exports = __webpack_public_path__ + "img/SL-M-220-240.c1554d04.svg";